const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const AddTime = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADMIN_ADD_TIME_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'ADMIN_ADD_TIME_ERROR':
            return { loading: false, error: true, data: [] };
        case 'ADMIN_ADD_TIME_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'ADMIN_ADD_TIME_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default AddTime